import type { CDDStatus } from '../types/cdd-records.types';

const FAILURE_TOKENS = new Set([
	'stopped', 'failed', 'failedterminal', 'dismissed',
	'rejected', 'expired', 'cancelled', 'canceled',
]);
const COMPLETED_TOKENS = new Set(['complete', 'completed', 'approved', 'done']);

const STATUS_MAP: Record<string, CDDStatus> = {
	active: 'active',
	in_progress: 'in-progress',
	inprogress: 'in-progress',
	initial_results: 'in-progress',
	data_collection: 'in-progress',
	checks_in_progress: 'in-progress',
	remediation: 'in-progress',
	processing: 'in-progress',
	report_generation: 'in-progress',
	generating: 'in-progress',
	pending: 'pending',
	queued: 'pending',
	pending_review: 'pending-review',
	not_started: 'not-started',
	notstarted: 'not-started',
	inactive: 'inactive',
	archived: 'archived',
};

const normalizeToken = (value: unknown): string =>
	typeof value === 'string'
		? value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
		: '';

const containsToken = (value: string, tokens: Set<string>): boolean => {
	const compact = value.replace(/_/g, '');
	return tokens.has(value) || tokens.has(compact) || value.split('_').some((part) => tokens.has(part));
};

/** Normalize backend case values, with terminal outcomes taking precedence over processing stages. */
export function normalizeCDDStatus(...values: unknown[]): CDDStatus {
	const normalized = values.map(normalizeToken).filter(Boolean);
	if (normalized.some((value) =>
		containsToken(value, FAILURE_TOKENS) || value.includes('failed_terminal') || value.includes('failedterminal')
	)) return 'failed';
	if (normalized.some((value) => containsToken(value, COMPLETED_TOKENS))) return 'completed';
	if (normalized.some((value) => containsToken(value, new Set(['active'])))) return 'active';
	for (const value of normalized) {
		if (STATUS_MAP[value]) return STATUS_MAP[value];
	}
	return 'pending';
}
